import { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import axios from 'axios';
import { EnvelopeSimple, Prohibit } from '@phosphor-icons/react';
import { useAuth, isAdmin } from '@/auth/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

/** 管理者にだけ出す「メールが止まっている」帯。
 *
 * 封じ込めは preview では正しい動作だが、本番で誤って有効になると
 * 「メールが黙って止まり1週間誰も気づかない」という障害そのものになる。
 * 起動ログとテスト送信は“探しに行かないと見えない”ので、探さなくても
 * 見える場所に出す。止まっていないときは何も描かない。 */
export default function MailContainmentBanner() {
  const location = useLocation();
  const { user } = useAuth();
  const admin = isAdmin(user);
  const [state, setState] = useState(null);
  useEffect(() => {
    let alive = true;
    if (!admin) { setState(null); return undefined; }
    axios.get(`${API}/api/email-settings/containment`)
      .then((r) => { if (alive) setState(r.data); })
      .catch(() => { if (alive) setState(null); });
    return () => { alive = false; };
  }, [admin]);
  const p = location.pathname || '';
  // 社外向けの公開ページ（/s/ の共有リンク）には社内の帯を出さない。
  if (p.startsWith('/s/') || p.startsWith('/g/') || p.startsWith('/b/')) return null;
  if (p.endsWith('/print') || p.includes('/print/') || p.startsWith('/mfg/kiosk')) return null;
  if (!state?.enabled) return null;
  const redirect = state.mode === 'redirect';
  return (
    <div className="no-print fixed top-0 inset-x-0 z-[9998] flex justify-center px-2 pt-2 pointer-events-none">
      <div
        className="pointer-events-auto flex items-center gap-2 rounded-md bg-rose-700 text-white text-xs font-bold px-3 py-2 shadow-lg"
        data-testid="mail-containment-banner"
      >
        {redirect
          ? <EnvelopeSimple size={16} weight="fill" className="shrink-0" />
          : <Prohibit size={16} weight="bold" className="shrink-0" />}
        <span>
          {redirect
            ? `メール転送中 — 業務メールは ${(state.sink || []).join('、')} にのみ届いています`
            : 'メール送信停止中 — 新規依頼・入荷のお知らせは誰にも届いていません'}
          {typeof state.recent_24h === 'number' && `（直近24時間 ${state.recent_24h} 件）`}
        </span>
        <Link
          to="/settings/email"
          className="underline underline-offset-2 hover:no-underline shrink-0"
          data-testid="mail-containment-banner-link"
        >
          詳細
        </Link>
      </div>
    </div>
  );
}
